import React from 'react';
import { css } from '@emotion/react';

import type { RowProps } from 'shared/components/nv-table';
import NvTableCells from 'shared/components/nv-table/nv-table-cells';
import { shadedWhite } from 'athena/styles/colors';
import OptionsCell from './options-cell';
import ConnectionsCell from './connections-cell';
import { MentoringProgramEnrollment } from 'redux/schemas/models/mentoring-program-enrollments';
import { config } from '@config/pendo.config.json';
import StatusCell from './status-cell';
import NameCell from './name-cell';
import AvailabilityCell from './availability-cell';
import { gray7 } from 'styles/global_defaults/colors';
import { ColumnID } from './types';

const cells = {
  [ColumnID.NAME]: NameCell,
  [ColumnID.STATUS]: StatusCell,
  [ColumnID.ASSIGNED]: ConnectionsCell,
  [ColumnID.AVAILABILITY]: AvailabilityCell,
  [ColumnID.OPTIONS]: OptionsCell,
};

const styles = css`
  border-bottom: 1px solid ${shadedWhite};

  &:hover {
    background-color: ${gray7};

    .options-target {
      opacity: 1;
    }
  }

  &:last-of-type {
    border-bottom: 0;
  }
`;

const ParticipantRow = (props: RowProps<MentoringProgramEnrollment>) => {
  const { row, className, getCellStyle } = props;
  const { original } = row || {};
  const { id } = original || {};

  const dataQATag = config.pendo.athena.mentorshipProgram.participants.participantRow;

  return (
    <div css={styles} className={className} data-qa={`${dataQATag}_${id}`}>
      <NvTableCells row={row} getCellStyle={getCellStyle} cellMap={cells} />
    </div>
  );
};

export default ParticipantRow;

